import { apiRequest } from './client'
import type { GeneralSettings } from './types'

export const settingsApi = {
  get: () => apiRequest<{ data: GeneralSettings }>('/settings'),

  update: (input: Partial<GeneralSettings>) =>
    apiRequest<{ data: GeneralSettings }>('/settings', { method: 'PATCH', body: input }),
}
